import * as urls from "./urls";

export const getUrlFromLargeGroupSurvey = (largeGroupSurvey) =>
  largeGroupSurvey?.completedQuoteRequest ? `${urls.baseURL}${urls.doneURL}` : `${urls.baseURL}${urls.requestQuoteURL}`;
